

import { useTheme } from "../../hooks/use-theme";
import { Footer } from "../../layouts/footer";
import {
  CreditCard,
  DollarSign,
  Package,
  PencilLine,
  Star,
  Trash,
  TrendingDown,
  TrendingUp,
  Users,
} from "lucide-react";
import { getStats } from "../../api/dashboardApi";
import { useEffect, useState } from "react";
import MonthlyIncomeChart from "./IncomeGaph";
import LatestOrders from "./LatesOrders";
import { Link } from "react-router-dom";
import DashBoard from "../../pages/dashboard/DashBoard";


const DashboardPage = () => {
  const { theme } = useTheme();

  const [stats, setStats] = useState(null);
  const [initialLoading, setInitialLoading] = useState(true);
  const [statsLoading, setStatsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [timePeriod, setTimePeriod] = useState("week");




  // Error state
  if (error) {
    return (
      <div className="flex h-64 w-full items-center justify-center">
        <div className="rounded-lg bg-_red/20 text-_red p-4">
          <p>{error}</p>
          <button
            className="mt-2 rounded px-4 py-2 bg-_red text-_white hover:opacity-90"
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-y-6 px-1 py-4 md:px-4">
      <DashBoard setIsLoading = {setInitialLoading}/>

      <Footer className="mt-6" />
    </div>
  );
};

export default DashboardPage;
